import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import queryString from "query-string";

import QuestionsView from "./questions-view";

export default () => {
  let history = useHistory();

  const [activeStep, setActiveStep] = useState(0);

  const [age, setAge] = useState(21);
  const [startingCapital, setStartingCapital] = useState(null);
  const [monthlyDeposit, setMonthlyDeposit] = useState(null);
  const [riskToleranceMod, setRiskToleranceMod] = useState(0);
  const [riskToleranceOptions, setRiskToleranceOptions] = useState([]);

  useEffect(() => {
    let options = [];
    if (startingCapital < 10_000) {
      options = [];
    } else if (startingCapital < 150_000) {
      options = [
        { label: "🙄 20%", value: -0.0015 },
        { label: "🤔 30%", value: 0 },
        { label: "🤩 50%", value: 0.0015 },
      ];
    } else if (startingCapital < 1_000_000) {
      options = [
        { label: "🙄 10%", value: -0.0025 },
        { label: "🤔 20%", value: 0 },
        { label: "🤩 30%", value: 0.0005 },
      ];
    } else {
      options = [
        { label: "🙄 10%", value: 0.0002 },
        { label: "🤔 20%", value: 0.0005 },
      ];
    }

    setRiskToleranceOptions(options);
    if (startingCapital < 10_000) {
      setRiskToleranceMod(null);
    } else {
      setRiskToleranceMod(options[1].value);
    }
  }, [startingCapital, monthlyDeposit]);

  const isAgeValid = age >= 21;
  const areAdvancedStepsEnabled = startingCapital >= 10_000;

  const handleNextStep = () => {
    if (isAgeValid) {
      setActiveStep(activeStep + 1);
    }
    if (areAdvancedStepsEnabled ? activeStep === 3 : activeStep === 2) {
      history.push({
        pathname: "/results",
        search: queryString.stringify({
          age,
          startingCapital,
          monthlyDeposit,
          riskToleranceMod,
        }),
      });
    }
  };

  const handlePreviousStep = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <QuestionsView
      activeStep={activeStep}
      handlePreviousStep={handlePreviousStep}
      handleNextStep={handleNextStep}
      age={age}
      isAgeValid={isAgeValid}
      handleAgeChange={(e) => setAge(parseInt(e.target.value))}
      startingCapital={startingCapital}
      handleStartingCapitalChange={(e) =>
        setStartingCapital(parseFloat(e.target.value))
      }
      monthlyDeposit={monthlyDeposit}
      handleMonthlyDepositChange={(e) =>
        setMonthlyDeposit(parseFloat(e.target.value))
      }
      riskToleranceMod={riskToleranceMod}
      handleRiskToleranceModChange={(e) =>
        setRiskToleranceMod(parseFloat(e.target.value))
      }
      riskToleranceOptions={riskToleranceOptions}
      handleInputKeyPress={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
          handleNextStep();
        }
      }}
    />
  );
};
